import React from 'react';
import RegisterForm from './pages/RegisterForm';
import Home from './pages/Home';
import { BrowserRouter, Navigate, Route, Routes} from 'react-router-dom';
import { Layout } from './components/Layout';
import SignIn from './pages/SignIn';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import ChangePassword from './pages/ChangePassword';
import ThankYou from './pages/ThankYou';
import BookingReport from './pages/BookingReport';
import ForgotPassword from './pages/ForgotPassword';

function App() {
  return (
    <BrowserRouter>
        <Routes>
          <Route path='/0ea299dc-f1a6-40d3-9837-24cc5e12fee9' element={ <BookingReport /> } />
          <Route path='/thankyou' element={<ThankYou />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/register" element={<RegisterForm />} />  
          <Route path='/changePassword' element={<ChangePassword />} />
          <Route path='/forgotPassword' element={<ForgotPassword />} />
          <Route index element={
              <RequireAuth>
                  <Layout>
                    <Home />                 
                  </Layout>                  
              </RequireAuth>
          }/>
        </Routes>
    </BrowserRouter>
  );
}

function RequireAuth({ children }) {
  const storedValue = localStorage.getItem("user");
  var authenticated = false;
  if(storedValue){
      authenticated = JSON.parse(storedValue)
  }
  return authenticated ? (children) : (<Navigate to="/signin" />);
}

export default App;

export const CurrentLanguage = () =>{
  return 'vi';
}

export const setCurrentLanguage = (lang) => {
  localStorage.setItem('language', lang);
}

export const getCurrentLanguage = () => {
  const storedValue = localStorage.getItem('language');
  return storedValue ? storedValue : 'vi';
}